export const adminActivityLog = {
  adminActivityLogs: "Admin Activity Logs",
  adminActivityLogs2: "Admin Activity Logs 2",
  from: "From",
  to: "To",
  advanceFilter: "Advance Filter",
  status: "Status",
  selectStatus: "SELECT STATUS",
  all: "ALL",
  pending: "PENDING",
  approved: "APPROVED",
  rejected: "REJECTED",
  userId: "User ID",
  username: "Username",
  action: "Action",
  updatedField: "Updated Field",
  originalValue: "Original Value",
  updatedValue: "Updated Value",
  notes: "Notes",
  cancel: "Cancel",
  filter: "Filter",
  updatedBy: "UPDATED BY",
  approvedBy: "APPROVED BY",
  updatedDate: "UPDATED DATE",
  status: "STATUS",
  originalValue: "ORIGINAL VALUE",
  updatedValue: "UPDATED VALUE",
  actionGroup: "ACTION GROUP",
  ipAddress: "IP ADDRESS",
  wallet: "WALLET",
  other: "OTHER",
  payment: "PAYMENT",
  player: "PLAYER",
};
